import styled from 'styled-components';
import { getFontSize } from '../utils/getFont';

const StyledButton = styled.button`
  background-color: ${(props) => (props.inverse ? props.backgroundColorHover || 'var(--background)' : props.backgroundColor || 'var(--primary-light)')};
  border: 2px solid ${(props) => (props.inverse ? props.color || 'var(--primary-light)' : props.backgroundColor || 'var(--primary-light)')};
  color: ${(props) => (props.inverse ? props.color || 'var(--primary-light)' : props.backgroundColor || 'var(--background)')} !important;

  svg {
    display: inline-block;
  }

  path {
    fill: ${(props) => (props.inverse ? props.color || 'var(--primary-light)' : props.backgroundColor || 'var(--background)')} !important;
  }

  ${({ rounded }) => rounded && `border-radius: 50px;`}

  display: inline-block;
  width: ${({ width }) => width || '200px'};
  margin-top: 0.5rem;
  padding: ${({ noPadding }) => (noPadding ? '0.25rem 1rem' : '0.5rem 1rem')};
  font-family: var(--text-subtitle);
  ${({fontSize}) => getFontSize(fontSize || 2)}
  text-decoration: none;

  cursor: pointer;
  * { cursor: pointer; }

  ${({ disabled }) => !disabled && `
    &:hover {
      background-color: ${(props) => props.inverse ? props.backgroundColor || 'var(--primary-light)' : props.backgroundColorHover || 'var(--background)'};
      border: 2px solid ${(props) => props.inverse ? props.color || 'var(--primary-light)' : props.colorHover  || 'var(--text)'};
      color: ${(props) => props.inverse ? props.color || 'var(--background)' : props.colorHover || 'var(--text)'} !important;

      path {
        fill: ${(props) =>props.inverse ? props.color || 'var(--background)' : props.colorHover || 'var(--text)'} !important;
      }

      transition: all 0.3s ease;
    }
  `}

  ${({ disabled }) => disabled && `
    filter: grayscale(40%) opacity(0.4);
    cursor: not-allowed;
  `}

`;

export const Button = ({ children, ...props }) => {
  // If prop 'color' or 'backgroundColor' doesnt start with # use the variables
  if (props.color && !props.color.startsWith('#')) {
    props.color = `var(${props.color})`;
  }
  if (props.colorHover && !props.colorHover.startsWith('#')) {
    props.colorHover = `var(${props.colorHover})`;
  }

  if (props.backgroundColor && !props.backgroundColor.startsWith('#')) {
    props.backgroundColor = `var(${props.backgroundColor})`;
  }
  if (props.backgroundColorHover && !props.backgroundColorHover.startsWith('#')) {
    props.backgroundColorHover = `var(${props.backgroundColorHover})`;
  }

  return <StyledButton {...props}>{children}</StyledButton>;
};
